/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { ProcessingRunRequest } from '../api-models';
// @ts-ignore
import { ProcessingRunStatusResponse } from '../api-models';
// @ts-ignore
import { ProcessingSetupResponse } from '../api-models';
/**
 * ToolsV2Api - axios parameter creator
 * @export
 */
export const ToolsV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancels the run. A queued job never starts; a running one stops after the employee in  flight, since each employee is its own transaction.
         * @param {string} jobId The job id returned when the run was queued.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsProcessingJobIdDelete: async (jobId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiV2ToolsProcessingJobIdDelete', 'jobId', jobId)
            const localVarPath = `/api/v2/tools/processing/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The run\'s state and progress, for polling.
         * @param {string} jobId The job id returned when the run was queued.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsProcessingJobIdGet: async (jobId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiV2ToolsProcessingJobIdGet', 'jobId', jobId)
            const localVarPath = `/api/v2/tools/processing/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Queues a processing run for the caller\'s facility. Time cards recalculate through the  calculation-range envelope with accruals; the accrual pass rebuilds each employee\'s  ledger from the earlier of the requested date and the earliest open pay period.
         * @param {ProcessingRunRequest} [processingRunRequest] The form\&#39;s choices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsProcessingPost: async (processingRunRequest?: ProcessingRunRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/tools/processing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processingRunRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Form defaults: the facility combo, the default accrual date, the run in flight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsProcessingSetupGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/tools/processing/setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ToolsV2Api - functional programming interface
 * @export
 */
export const ToolsV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ToolsV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancels the run. A queued job never starts; a running one stops after the employee in  flight, since each employee is its own transaction.
         * @param {string} jobId The job id returned when the run was queued.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ToolsProcessingJobIdDelete(jobId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessingRunStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ToolsProcessingJobIdDelete(jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary The run\'s state and progress, for polling.
         * @param {string} jobId The job id returned when the run was queued.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ToolsProcessingJobIdGet(jobId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessingRunStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ToolsProcessingJobIdGet(jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Queues a processing run for the caller\'s facility. Time cards recalculate through the  calculation-range envelope with accruals; the accrual pass rebuilds each employee\'s  ledger from the earlier of the requested date and the earliest open pay period.
         * @param {ProcessingRunRequest} [processingRunRequest] The form\&#39;s choices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ToolsProcessingPost(processingRunRequest?: ProcessingRunRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessingRunStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ToolsProcessingPost(processingRunRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Form defaults: the facility combo, the default accrual date, the run in flight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ToolsProcessingSetupGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessingSetupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ToolsProcessingSetupGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ToolsV2Api - factory interface
 * @export
 */
export const ToolsV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ToolsV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancels the run. A queued job never starts; a running one stops after the employee in  flight, since each employee is its own transaction.
         * @param {ToolsV2ApiApiV2ToolsProcessingJobIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsProcessingJobIdDelete(requestParameters: ToolsV2ApiApiV2ToolsProcessingJobIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<ProcessingRunStatusResponse> {
            return localVarFp.apiV2ToolsProcessingJobIdDelete(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The run\'s state and progress, for polling.
         * @param {ToolsV2ApiApiV2ToolsProcessingJobIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsProcessingJobIdGet(requestParameters: ToolsV2ApiApiV2ToolsProcessingJobIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<ProcessingRunStatusResponse> {
            return localVarFp.apiV2ToolsProcessingJobIdGet(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Queues a processing run for the caller\'s facility. Time cards recalculate through the  calculation-range envelope with accruals; the accrual pass rebuilds each employee\'s  ledger from the earlier of the requested date and the earliest open pay period.
         * @param {ToolsV2ApiApiV2ToolsProcessingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsProcessingPost(requestParameters: ToolsV2ApiApiV2ToolsProcessingPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ProcessingRunStatusResponse> {
            return localVarFp.apiV2ToolsProcessingPost(requestParameters.processingRunRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Form defaults: the facility combo, the default accrual date, the run in flight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsProcessingSetupGet(options?: AxiosRequestConfig): AxiosPromise<ProcessingSetupResponse> {
            return localVarFp.apiV2ToolsProcessingSetupGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2ToolsProcessingJobIdDelete operation in ToolsV2Api.
 * @export
 * @interface ToolsV2ApiApiV2ToolsProcessingJobIdDeleteRequest
 */
export interface ToolsV2ApiApiV2ToolsProcessingJobIdDeleteRequest {
    /**
     * The job id returned when the run was queued.
     * @type {string}
     * @memberof ToolsV2ApiApiV2ToolsProcessingJobIdDelete
     */
    readonly jobId: string
}

/**
 * Request parameters for apiV2ToolsProcessingJobIdGet operation in ToolsV2Api.
 * @export
 * @interface ToolsV2ApiApiV2ToolsProcessingJobIdGetRequest
 */
export interface ToolsV2ApiApiV2ToolsProcessingJobIdGetRequest {
    /**
     * The job id returned when the run was queued.
     * @type {string}
     * @memberof ToolsV2ApiApiV2ToolsProcessingJobIdGet
     */
    readonly jobId: string
}

/**
 * Request parameters for apiV2ToolsProcessingPost operation in ToolsV2Api.
 * @export
 * @interface ToolsV2ApiApiV2ToolsProcessingPostRequest
 */
export interface ToolsV2ApiApiV2ToolsProcessingPostRequest {
    /**
     * The form\&#39;s choices.
     * @type {ProcessingRunRequest}
     * @memberof ToolsV2ApiApiV2ToolsProcessingPost
     */
    readonly processingRunRequest?: ProcessingRunRequest
}

/**
 * ToolsV2Api - object-oriented interface
 * @export
 * @class ToolsV2Api
 * @extends {BaseAPI}
 */
export class ToolsV2Api extends BaseAPI {
    /**
     * 
     * @summary Cancels the run. A queued job never starts; a running one stops after the employee in  flight, since each employee is its own transaction.
     * @param {ToolsV2ApiApiV2ToolsProcessingJobIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsV2Api
     */
    public apiV2ToolsProcessingJobIdDelete(requestParameters: ToolsV2ApiApiV2ToolsProcessingJobIdDeleteRequest, options?: AxiosRequestConfig) {
        return ToolsV2ApiFp(this.configuration).apiV2ToolsProcessingJobIdDelete(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The run\'s state and progress, for polling.
     * @param {ToolsV2ApiApiV2ToolsProcessingJobIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsV2Api
     */
    public apiV2ToolsProcessingJobIdGet(requestParameters: ToolsV2ApiApiV2ToolsProcessingJobIdGetRequest, options?: AxiosRequestConfig) {
        return ToolsV2ApiFp(this.configuration).apiV2ToolsProcessingJobIdGet(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Queues a processing run for the caller\'s facility. Time cards recalculate through the  calculation-range envelope with accruals; the accrual pass rebuilds each employee\'s  ledger from the earlier of the requested date and the earliest open pay period.
     * @param {ToolsV2ApiApiV2ToolsProcessingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsV2Api
     */
    public apiV2ToolsProcessingPost(requestParameters: ToolsV2ApiApiV2ToolsProcessingPostRequest = {}, options?: AxiosRequestConfig) {
        return ToolsV2ApiFp(this.configuration).apiV2ToolsProcessingPost(requestParameters.processingRunRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Form defaults: the facility combo, the default accrual date, the run in flight.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsV2Api
     */
    public apiV2ToolsProcessingSetupGet(options?: AxiosRequestConfig) {
        return ToolsV2ApiFp(this.configuration).apiV2ToolsProcessingSetupGet(options).then((request) => request(this.axios, this.basePath));
    }
}
